export function getDateByKeyword(keyword) {
  const today = new Date();
  const pad = (n) => n.toString().padStart(2, '0');
  const format = (date) => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

  const startOfWeek = (date) => {
    const d = new Date(date);
    const day = d.getDay(); // 0 (Sun) to 6 (Sat)
    const diff = d.getDate() - day + (day === 0 ? -6 : 1); // Monday as start
    return new Date(d.setDate(diff));
  };

  const endOfWeek = (date) => {
    const start = startOfWeek(date);
    return new Date(start.getFullYear(), start.getMonth(), start.getDate() + 6);
  };

  const startOfMonth = (date) => new Date(date.getFullYear(), date.getMonth(), 1);
  const endOfMonth = (date) => new Date(date.getFullYear(), date.getMonth() + 1, 0);

  const getQuarter = (month) => Math.floor(month / 3) + 1;
  const quarterStartEnd = (q, year) => {
    const startMonths = [0, 3, 6, 9];
    const endMonths = [2, 5, 8, 11];
    return {
      start: new Date(year, startMonths[q - 1], 1),
      end: new Date(year, endMonths[q - 1] + 1, 0)
    };
  };

  const year = today.getFullYear();
  const month = today.getMonth();
  const date = today.getDate();

  switch (keyword.toLowerCase()) {
    case 'today':
      return format(today);
    case 'yesterday':
      return format(new Date(year, month, date - 1));
    case 'tomorrow':
      return format(new Date(year, month, date + 1));
    case 'startofweek':
      return format(startOfWeek(today));
    case 'endofweek':
      return format(endOfWeek(today));
    case 'lastweek':
      return format(new Date(year, month, date - 7));
    case 'startofmonth':
      return format(startOfMonth(today));
    case 'endofmonth':
      return format(endOfMonth(today));
    case 'lastmonth':
      const lastMonth = new Date(year, month - 1, date);
      return format(lastMonth);
    case 'startofquarter1':
      return `${year}-01-01`;
    case 'endofquarter1':
      return `${year}-03-31`;
    case 'startofquarter2':
      return `${year}-04-01`;
    case 'endofquarter2':
      return `${year}-06-30`;
    case 'startofquarter3':
      return `${year}-07-01`;
    case 'endofquarter3':
      return `${year}-09-30`;
    case 'startofquarter4':
      return `${year}-10-01`;
    case 'endofquarter4':
      return `${year}-12-31`;
    case 'startofthisquarter': {
      const q = getQuarter(month);
      return format(quarterStartEnd(q, year).start);
    }
    case 'endofthisquarter': {
      const q = getQuarter(month);
      return format(quarterStartEnd(q, year).end);
    }
    case 'startlastquarter': {
      const q = getQuarter(month);
      const lastQ = q - 1 === 0 ? 4 : q - 1;
      const lastYear = q - 1 === 0 ? year - 1 : year;
      return format(quarterStartEnd(lastQ, lastYear).start);
    }
    case 'endlastquarter': {
      const q = getQuarter(month);
      const lastQ = q - 1 === 0 ? 4 : q - 1;
      const lastYear = q - 1 === 0 ? year - 1 : year;
      return format(quarterStartEnd(lastQ, lastYear).end);
    }
    case 'startnextquarter': {
      const q = getQuarter(month);
      const nextQ = q + 1 > 4 ? 1 : q + 1;
      const nextYear = q + 1 > 4 ? year + 1 : year;
      return format(quarterStartEnd(nextQ, nextYear).start);
    }
    case 'endnextquarter': {
      const q = getQuarter(month);
      const nextQ = q + 1 > 4 ? 1 : q + 1;
      const nextYear = q + 1 > 4 ? year + 1 : year;
      return format(quarterStartEnd(nextQ, nextYear).end);
    }
    case 'startofyear':
      return `${year}-01-01`;
    case 'endofyear':
      return `${year}-12-31`;
    case 'last year':
      return format(new Date(year - 1, month, date));
    case 'last2years':
      return format(new Date(year - 2, month, date));
    default:
      return 'Invalid keyword';
  }
}

export function replaceKeywordsInUrl(url) {
  return url.replace(/':\[(.*?)\]:'/g, (_, keyword) => `'${getDateByKeyword(keyword)}'`);
}

export function replaceKeywordsInText(text) {
  return text.replace(/:\[(.*?)\]:/g, (_, keyword) => getDateByKeyword(keyword));
}

export function normalizeNumericStringsInRecords(records = []) {
  return records.map((record) => {
    const normalized = {};

    for (const [key, value] of Object.entries(record)) {
      if (typeof value === 'string') {
        const numericValue = parseFloat(value.replace(/,/g, ''));
        normalized[key] = isNaN(numericValue) ? value : numericValue;
      } else {
        normalized[key] = value;
      }
    }

    return normalized;
  });
}